import { mergeStyleSets } from '@uifabric/merge-styles';
import get from 'lodash/get';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  ignoredDLIds: {
    fontSize: get(theme, 'fonts.medium.fontSize'),
    lineHeight: get(theme, 'fonts.medium.lineHeight'),
    fontWeight: get(theme, 'fonts.medium.fontWeight'),
    fontFamily: get(theme, 'fonts.medium.fontFamily'),
    display: 'block',
    marginBottom: pxToRem(6),
  },
  searchKeyBtn: {
    marginTop: '40px',
  },
  messageBar: {
    marginTop: pxToRem(5),
  },
});
